import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/reports/relationUserAggregator/filter'; // Importing Filter component
import Table from 'views/partner/reports/relationUserAggregator/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the relation user aggregator view.
 * @extends JetView
 */
export default class relationUserAggregatoView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [], // Placeholder for future rows
        };
        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for change event
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
            ],
        };
        const left = {
            rows: [Filter, { id: 'res2', view: 'resizer' }, Table, toolbar], // Layout for the left side
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Type of the view
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide', // Type of the row
                    cols: [left], // Columns containing the left layout
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('res2').hide(); // Hide the resizer if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
